import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cut_ic_clickmore",
  "use": "icon-cut_ic_clickmore-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-cut_ic_clickmore\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#FFF\" d=\"M0 0h24v24H0z\" /><path d=\"m4 5 8 7 8-7M4 12l8 7 8-7\" stroke=\"#6E86B1\" stroke-width=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol